import React, { useEffect, useState } from "react";
import {
  createOneCApiKey,
  getOneCApiKeys,
  updateOneCApiKey,
} from "./api";
import "./OneCApiKeys.css";

function OneCApiKeys() {
  const [clients, setClients] = useState([]);
  const [clientName, setClientName] = useState("");
  const [ipAllowlist, setIpAllowlist] = useState("");
  const [createdKey, setCreatedKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState("");

  const fetchClients = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await getOneCApiKeys();
      setClients(data.clients || []);
    } catch (err) {
      setError(err.response?.data?.error || "Ошибка загрузки ключей");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  const handleCreate = async (event) => {
    event.preventDefault();
    if (!clientName.trim()) {
      setError("Введите название клиента");
      return;
    }

    setCreating(true);
    setError("");
    setCreatedKey("");

    try {
      const ipList = ipAllowlist
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);

      const data = await createOneCApiKey({
        clientName: clientName.trim(),
        ipAllowlist: ipList,
      });

      setCreatedKey(data.apiKey || "");
      setClientName("");
      setIpAllowlist("");
      await fetchClients();
    } catch (err) {
      setError(err.response?.data?.error || "Ошибка создания ключа");
    } finally {
      setCreating(false);
    }
  };

  const handleToggle = async (client) => {
    try {
      await updateOneCApiKey(client.id, { enabled: !client.enabled });
      await fetchClients();
    } catch (err) {
      setError(err.response?.data?.error || "Ошибка обновления ключа");
    }
  };

  const handleCopy = async () => {
    if (!createdKey) return;

    try {
      await navigator.clipboard.writeText(createdKey);
      alert("Ключ скопирован");
    } catch (_) {
      alert("Не удалось скопировать автоматически");
    }
  };

  const formatDate = (value) => {
    if (!value) return "—";
    return new Date(value).toLocaleString("ru-RU");
  };

  return (
    <div className="one-c-api-page">
      <div className="one-c-api-header">
        <h2>1C API ключи</h2>
        <button onClick={fetchClients} disabled={loading}>
          {loading ? "Загрузка..." : "Обновить"}
        </button>
      </div>

      <form className="one-c-api-form" onSubmit={handleCreate}>
        <label>
          Клиент
          <input
            type="text"
            value={clientName}
            onChange={(event) => setClientName(event.target.value)}
            placeholder="РусСилика PROD"
          />
        </label>

        <label>
          IP allowlist
          <input
            type="text"
            value={ipAllowlist}
            onChange={(event) => setIpAllowlist(event.target.value)}
            placeholder="203.0.113.10, 10.10.0.0/16"
          />
        </label>

        <button type="submit" disabled={creating}>
          {creating ? "Создание..." : "Создать ключ"}
        </button>
      </form>

      {createdKey && (
        <div className="one-c-api-secret">
          <div>
            <strong>Новый ключ</strong>
            <code>{createdKey}</code>
          </div>
          <button onClick={handleCopy}>Скопировать</button>
        </div>
      )}

      {error && <div className="one-c-api-error">{error}</div>}

      <table className="one-c-api-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Клиент</th>
            <th>Ключ</th>
            <th>Статус</th>
            <th>IP allowlist</th>
            <th>Создан</th>
            <th>Последний запрос</th>
            <th>Действия</th>
          </tr>
        </thead>
        <tbody>
          {clients.map((client) => (
            <tr key={client.id}>
              <td>{client.id}</td>
              <td>{client.clientName}</td>
              <td className="one-c-api-mono">{client.keyPreview}</td>
              <td>
                <span className={client.enabled ? "api-status-on" : "api-status-off"}>
                  {client.enabled ? "Активен" : "Отключен"}
                </span>
              </td>
              <td>{client.ipAllowlist?.length ? client.ipAllowlist.join(", ") : "—"}</td>
              <td>{formatDate(client.createdAt)}</td>
              <td>{formatDate(client.lastUsedAt)}</td>
              <td>
                <button onClick={() => handleToggle(client)}>
                  {client.enabled ? "Отключить" : "Включить"}
                </button>
              </td>
            </tr>
          ))}
          {!clients.length && !loading && (
            <tr>
              <td colSpan="8" className="one-c-api-empty">
                Ключей пока нет
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default OneCApiKeys;
